import { render, staticRenderFns } from "./Warn.vue?vue&type=template&id=027a101e&"
import script from "./Warn.vue?vue&type=script&lang=js&"
export * from "./Warn.vue?vue&type=script&lang=js&"
import style0 from "./Warn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports